import Col from './col';
import Row from './row';
export default {
    Col: Col,
    Row: Row,
};
